<script lang="ts" setup>
const emit = defineEmits<{
  (event: 'mouseenter'): void
  (event: 'mouseleave'): void
  (event: 'focus'): void
  (event: 'blur'): void
}>()

const { events: hoverEvents, class: hoverClass } = useHover(emit, {})
</script>

<template>
  <div :class="['tw-badge', hoverClass]" role="presentation" v-on="{ ...hoverEvents }">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import "~/assets/styles/tw-variables.scss";
@import "~/assets/styles/tw-mixins.scss";

$tw-component--gap: 0.25em;
$lightGray: #dcdcdc;

@mixin tw-default-box-variant($type: 'box') {
  &:not(.tw-box-variant--box):not(.tw-box-variant--badge):not(.tw-box-variant--pill):not(.tw-box-variant--square):not(.tw-box-variant--badge-square):not(.tw-box-variant--circle):not(.tw-box-variant--#{$type}) {
    @if ($type =='box') {
      @include tw-box-variant--box;
    }

    @if ($type =='badge') {
      @include tw-box-variant--badge;
    }

    @if ($type =='pill') {
      @include tw-box-variant--pill;
    }

    @if ($type =='square') {
      @include tw-box-variant--square;
    }

    @if ($type =='badge-square') {
      @include tw-box-variant--badge-square;
    }

    @if ($type =='circle') {
      @include tw-box-variant--circle;
    }
  }
}

@mixin tw-color-set($color: null, $backgroundColor: null, $borderColor: null, $textDecorationColor: null) {
  color: $color;
  background-color: $backgroundColor;
  border-color: $borderColor;
  text-decoration-color: $textDecorationColor;
}

@mixin tw-box-variant--badge {
  border-radius: 0.333em;
}

.tw-badge {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: $tw-component--gap;
  padding: $tw-component--gap calc(#{$tw-component--gap} * 2);
  border: 1px solid transparent;
  @include tw-default-box-variant('badge');
  @include tw-color-set(inherit, $lightGray);
  transition: color, background-color, border-color, text-decoration-color;
  transition-duration: 0.15s;
  transition-timing-function: ease-in-out;
  user-select: none;

}
</style>
